/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Detail of a financial flow within a beneficiary total
 * @export
 * @interface BreakdownFluxDetailDto
 */
export interface BreakdownFluxDetailDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownFluxDetailDto
     */
    flowType: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownFluxDetailDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownFluxDetailDto
     */
    sourceGuarantee?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BreakdownFluxDetailDto
     */
    amount: number;
}

/**
 * Check if a given object implements the BreakdownFluxDetailDto interface.
 */
export function instanceOfBreakdownFluxDetailDto(value: object): value is BreakdownFluxDetailDto {
    if (!('flowType' in value) || value['flowType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function BreakdownFluxDetailDtoFromJSON(json: any): BreakdownFluxDetailDto {
    return BreakdownFluxDetailDtoFromJSONTyped(json, false);
}

export function BreakdownFluxDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownFluxDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'flowType': json['flowType'],
        'label': json['label'],
        'sourceGuarantee': json['sourceGuarantee'] == null ? undefined : json['sourceGuarantee'],
        'amount': json['amount'],
    };
}

export function BreakdownFluxDetailDtoToJSON(json: any): BreakdownFluxDetailDto {
    return BreakdownFluxDetailDtoToJSONTyped(json, false);
}

export function BreakdownFluxDetailDtoToJSONTyped(value?: BreakdownFluxDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flowType': value['flowType'],
        'label': value['label'],
        'sourceGuarantee': value['sourceGuarantee'],
        'amount': value['amount'],
    };
}

